if (!customElements.get('sb-announcement-slider')) {
  customElements.define('sb-announcement-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.show(0);
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.timer = window.setInterval(() => {
        if (!this.motionPreference.matches && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.show(this.index + 1);
      }, 4500);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  });
}
